import React from 'react';
import {connect} from 'react-redux';

const ParticipantAttributeGroup = ({attributes}) => {
    const group = attributes.first().group;

    return (
        <table className="participant-attrs">
            <caption>{group}</caption>
            <tbody>
                {attributes.map((attribute, i) => (
                    <ParticipantAttribute key={i} attribute={attribute}/>
                ))}
            </tbody>
        </table>
    );
};

const ParticipantAttribute = ({attribute}) => (
    <tr>
        <th style={{width: '50%'}}>{attribute.name}</th>
        <td>{attribute.value}</td>
    </tr>
);

const ParticipantAttributes = ({attributes}) => {
    if (!attributes.size) {
        return <div/>;
    }

    const transformed = attributes
        .sortBy(attribute => attribute.name)
        .sortBy(attribute => attribute.group)
        .groupBy(attribute => attribute.group);

    return (
        <div>
            {transformed.toIndexedSeq().toArray().map((group, i) => (
                <ParticipantAttributeGroup key={i} attributes={group}/>
            ))}
        </div>
    );
};

export default connect(
    (state) => ({
        attributes: state.get('participantParticipantAttributeValues').valueSeq()
    })
)(ParticipantAttributes);
